import { Component, OnInit, HostListener, Inject, forwardRef } from '@angular/core';
import { RoleService } from '../service/role.service';
import { CognitoService } from '../service/cognito.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../local-storage.service';
import { ClientService } from '../service/client.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from '../service/validation.service';
import { Router } from '@angular/router';
import { ThemeService } from '../service/theme.service';
import { NavigationService } from '../service/navigation.service';
import { Roles } from '../constants/roles';
import { SystemMessageService } from '../service/system-message.service';
import { LocalizationService } from '../service/localization.service';
import { Types } from '../constants/user-type';
import { TimeScale } from 'chart.js';


@Component({
    selector: 'app-user-create-client',
    templateUrl: './user-create-client.component.html',
    styleUrls: ['./user-create-client.component.css'],
    standalone: false
})

export class UserCreateClientComponent implements OnInit {

  Roles = Roles;
  Types = Types;

  public form: FormGroup

  // flag to handle the successMessage status
  public successMessage: boolean = false;

  // Google Places Autocomplete
  public autocomplete: any = google.maps.places;

  // Array Fetch customer data
  public clientsData: any[] = [];
  public clientArray: any[] = [];
  public newClientArray: any [] = [];

  public map: any = {};

  public validateRolesCheckBox: boolean = false;
  public validateDistributorSelect: boolean = false;

  // Variable used to display system message to the user
  public systemMessage: string = '';

  //variable for ng-select placeholder
  placeholderText: string = 'clientName';

  // Variable to store the result of a place selection from Google Places Autocomplete.
  // It can hold a valid PlaceResult object or be undefined if no place is selected.
  selectedPlace: google.maps.places.PlaceResult | undefined;

  constructor(
    private localStorageService: LocalStorageService,
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
    public cognitoService: CognitoService,
    public roleService: RoleService,
    public clientService: ClientService,
    private formBuilder: FormBuilder,
    public validationService: ValidationService,
    private router: Router,
    public theme: ThemeService,
    public navigationService: NavigationService,
    public systemMessageService: SystemMessageService,
    public localizationService: LocalizationService
  ) {

    // Create a form using the FormBuilder
    this.form = this.formBuilder.group({
      // Define form controls and their initial values
      client_name: ['', Validators.required],
      legal_name: [''],
      email: ['', [Validators.required, Validators.email]],
      phone_number: [''],
      address: ['']
    });

    this.cognitoService.confirmValidUser();
    this.roleService.getRoles();
  }

  async ngOnInit() {
    await this.cognitoService.getUserType();
    this.systemMessageService.buttonBlocked = false;



    // Clear the existing data on cognito user data
    this.cognitoService.clearCognitoUserData();
    this.getClientList(); // to fill option of select client input
    this.localizationService.initAutocomplete(); // init the google api auto complete
    if(this.cognitoService.userType === 'client'){
      this.cognitoService.cognitoUserData.custom_client_id = this.cognitoService.clientId;
    }
  }

  disableButton() {
    this.systemMessageService.buttonBlocked = true;
  }

  // function used to get the list of clients
  getClientList() {
    try {
      // Use the clientService to fetch client data from an API
      this.clientService.getClients().subscribe(
        // Successful response callback
        (response: any) => {
          // Store the API response in the clientsData array
          this.clientsData = response;

          // Create a copy of the clientArray for further processing
          this.clientArray = this.clientsData;

          // remove Muirwood Studio from client List to display correctly to selection client list
          //this.clientArray = this.clientArray.filter(client => client.client_name !== 'Muirwood Studio');

          // Deduplicate client data based on client_name and client_id
          this.newClientArray = this.clientArray.reduce((accumulator, item) => {
            const key = item.client_name + item.client_id;
            if (!this.map[key]) {
              this.map[key] = true;
              // Add unique clients to the newClientArray
              accumulator.push({ client_id: item.client_id, client_name: item.client_name });
            }
            return accumulator;
          }, []);
        }
      );
    } catch (error) {
      // Handle and log any errors that occur during the process
      console.error("Error: ", error);
    }
  }

  // Function used to remove text on select client name placeholder
  onOptionSelected(): void {
    if (this.cognitoService.cognitoUserData.custom_client_id) {
      this.placeholderText = "";
    } else {
      this.placeholderText = 'clientName';
    }
  }

  // Decorator @HostListener listens to the 'input' event on the specified target element
  @HostListener('input', ['$event.target']) onInput(input: HTMLInputElement): void {
    // Check if the input element has the class 'telefone-input'
    if (input.classList.contains('telefone-input')) {
      // Remove all non-numeric characters from the input value
      const value = input.value.replace(/\D/g, '');

      // Check if the value has a length of 10 characters or less
      if (value.length <= 10) {
        // Format the phone number as (000) 000-0000
        input.value = this.formatPhoneNumber(value);
      } else {
        // If the value is longer than 10 digits, limit the input to 10 digits
        input.value = input.value.slice(0, 10);
      }
    }
  }

  // Function called when user click on creation button
  async createUser(){
    // Set the address of the cognito user data
    this.cognitoService.cognitoUserData.address = this.localizationService.autoCompletionReturnAddress;

    // Remove non-numeric characters from the phone number using the validationService
    this.validationService.keepOnlyNumbers(this.cognitoService.cognitoUserData.phone_number);
    // Update the client's phone number and creation date with the formatted values
    this.cognitoService.cognitoUserData.phone_number = this.validationService.phoneNumberFixed;


    // // Check the validation of all fields
    this.validationService.checkValidationAllInputs();

    if(this.validationService.usernameValid &&
      this.validationService.givenNameValid &&
      this.validationService.familyNameValid &&
      this.validationService.clientEmailValid &&
      this.validationService.userRolesValid){

        try {
          // Attempt to sign up the user and send a temporary password
          await this.cognitoService.UserSignUpAndSendTemporaryPassword(Types[1].label, Roles[1].label);

           // Variable used by bin-model-list html to show the proper message on success updating bin model
          sessionStorage.setItem("from", "user-create");

          // If cognito add user doesn't break then return to admin or client-user-list depending of the user role
          if(this.cognitoService.userType === 'muirwood'){
            // Redirect user in admin user list if user type is muirwood
            this.router.navigate(['/admin']);
          }else if(this.cognitoService.userType === 'client'){
            // Redirect user in client user list if user type is client
            this.router.navigate(['/client-user-list']);
          }
        }catch(error: any){
          if (error.response && error.response.status === 400) {
            // Handle 400 Bad Request errors
            if (error.name === 'UsernameExistsException') {
              console.error("Bad Request: User account already exists.");

              // Set the message throw to the user
              this.systemMessage = 'userAlreadyExist';

            } else {
              // Log an error if the 400 error is not due to an existing username
              console.error("Error creating user:", error.message);
            }
          } else {
            // Handle unexpected errors
            if(error.toString().includes("UsernameExistsException")){
              // Set the message throw to the user
              this.systemMessage = 'userAlreadyExist';
            }
            console.error("Unexpected error:", error);
          }

          if(error.toString().includes("InvalidParameterException") && error.toString().includes("username")){
            this.systemMessage = "invalidUsernameFormat"
          }

          this.systemMessageService.buttonBlocked = true;
          // Set the username as invalid if error = UsernameExistsException: User account already exists
          this.systemMessageService.selectRibbon('danger', this.systemMessage);
        }
      }else{
        this.systemMessageService.buttonBlocked = true;
        // Set the message error throwed to the uer
        this.systemMessage = 'fieldEmptyOrIncorrect';
        // throw the message to the user
        this.systemMessageService.selectRibbon('danger', this.systemMessage);
      }
  }

  // function to reload page when cancel button is clicked
  returnToAdmin() {
    this.localStorageService.addItem('adminContent', 'user-list')
    this.router.navigate(['/admin']); // Redirect to the '/admin' route after the delay
  }

  // Function that redirect user depending on his user type
  toPreviousPage(){
    const from = sessionStorage.getItem('createClient')
    if(from){
      switch(from){
        case 'dashboard':
          this.router.navigate(['/dashboard'])
          break;
        case 'client-user-list':
          this.router.navigate(['/client-user-list'])
          break;
      }
    }else{
      this.router.navigate(['/admin']);
    }
    sessionStorage.removeItem('createClient')
  }

  // Function to format a numeric string as a phone number in the format (000) 000-0000
  formatPhoneNumber(value: string): string {
    // Check if the input value is empty and return an empty string if it is
    if (value.length === 0) return '';

    // Extract the area code, first part, and second part of the phone number
    const areaCode = value.slice(0, 3);
    const firstPart = value.slice(3, 6);
    const secondPart = value.slice(6, 10);

    // Format the phone number as (000) 000-0000 and return the formatted string
    return `(${areaCode}) ${firstPart}-${secondPart}`;
  }

  // Function that avoid submitting the page when user press enter at the end of inputting address in address input
  onInputAddressKeydown(event: KeyboardEvent): void {
    if(event.key === 'Enter'){
      event.preventDefault(); // Don't submit the page
    }
  }

  /**
   * Simple function that return true or false depending if we want to NOT display a role in the HTML role container
   * @param role
   * @returns
   */
  clientRolesToBeDisplayed(role : string){
    switch(role){
      case '_distributor':
      case '_operations':
      case '_driver':
      case '_dispatch':
      case '_maintenance':
        return false;
        break;

      default:
        return true;
        break;
    }
  }
}
